import type { CreditExplanationVariant } from "../components/CancellationCreditExplanationModal";
import type { ShiftCancelPageDataSuccessful } from "../hooks/useShiftCancelPageData";

export function getCreditExplanationVariant(
  data:
    | Pick<
        ShiftCancelPageDataSuccessful,
        "isAfterShiftStart" | "isWithinECWindow" | "creditBenefit"
      >
    | undefined
): CreditExplanationVariant {
  if (!data) {
    return "no-benefit";
  }

  if (data.isAfterShiftStart) {
    return "after-shift-start";
  }

  if (data.isWithinECWindow && data.creditBenefit <= 0) {
    return "no-benefit";
  }

  return "before-ec-window";
}
